import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import { classNames } from "../helpers";
import notificationsApi from "../api/notifications";

import Button from "./Button.jsx";
import Dropdown from "./Dropdown.jsx";
import Icon from "./Icon.jsx";
import TopBarNotificationsPullout from "./TopBarNotificationsPullout.jsx";
import { sendError } from "../errors.js";
import {
  selectNotifications,
  setNotifications,
} from "../store/notificationsSlice.js";

export default function TopBarNotificationsMenu(props) {
  const [_loading, setLoading] = useState(true);
  const notifications = useSelector(selectNotifications);
  const dispatch = useDispatch();

  // Temporary disabled since we release first without
  return null;

  // useEffect(async () => {
  //   setLoading(true);
  //   try {
  //     const result = await notificationsApi.fetchAll();
  //     dispatch(setNotifications(result));
  //   } catch (err) {
  //     console.error(err);
  //     sendError(err);
  //   }
  //   setLoading(false);
  // }, []);

  // return (
  //   <>
  //     <Dropdown
  //       triggerClass="inline-flex-center"
  //       element={({ close }) => (
  //         <TopBarNotificationsPullout items={notifications} close={close} />
  //       )}
  //     >
  //       <Button
  //         circular
  //         small
  //         flat
  //         class={classNames(
  //           "top-bar-notifications-menu",
  //           notifications.length > 0 && "top-bar-notifications-menu--unread",
  //           props.class
  //         )}
  //       >
  //         <Icon>bell</Icon>
  //       </Button>
  //     </Dropdown>
  //   </>
  // );
}
